export const CARGAR_NUEVO_EMPLEADO_MODULE_ID = 'cargar_nuevo_empleado'
export const RECURSOS_HUMANOS_CATEGORY_ID = 'recursos_humanos'

export { defaultConfiguracionEquipoAccess as defaultCargarNuevoEmpleadoAccess } from './configuracionEquipoModule'
